import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';
import { getDisplayDate } from 'utils/date';

import './discovery-content-results-image-overlay.scss';

applyTranslations(require('./discovery-content-results-image-overlay.i18n.json'));

type Props = {
  size: 'small' | 'large',
  likes?: number,
  comments?: number,
  engagementRate: number,
  date: string,
  icon: {
    width: number,
    height: number
  }
};

const msgKey = 'discovery_content_results_image_overlay';

class DiscoveryContentImageOverlay extends React.PureComponent<Props> {
  static defaultProps = {
    likes: 0,
    comments: 0,
    engagementRate: 0,
    date: ''
  };

  renderIcon(name: string): React.ReactNode {
    const { icon, size } = this.props;

    const iconClasses = classnames({
      'discovery-content-results-image-overlay__icon': true,
      [`discovery-content-results-image-overlay__icon--size-${size}`]: size
    });

    return (
      <div className={iconClasses}>
        <SVGDynamicIcon
          name={name}
          width={icon.width}
          height={icon.height}
          customColor="white"
        />
      </div>
    );
  }

  renderLikes(): React.ReactNode {
    const { likes } = this.props;

    return (
      <div className="discovery-content-results-image-overlay__item">
        <div
          className="discovery-content-results-image-overlay__item-container"
          title={__t(`${msgKey}.labels.likes`)}
        >
          {this.renderIcon('heart-custom-fg')}
          <div className="discovery-content-results-image-overlay__item-value">
            {abbrNum(likes)}
          </div>
        </div>
      </div>
    );
  }

  renderComments(): React.ReactNode {
    const { comments } = this.props;

    return (
      <div className="discovery-content-results-image-overlay__item">
        <div
          className="discovery-content-results-image-overlay__item-container"
          title={__t(`${msgKey}.labels.comments`)}
        >
          {this.renderIcon('speech-bubble-custom-fg')}
          <div className="discovery-content-results-image-overlay__item-value">
            {abbrNum(comments)}
          </div>
        </div>
      </div>
    );
  }

  renderEngagementRate(): React.ReactNode {
    const { engagementRate } = this.props;

    return (
      <div className="discovery-content-results-image-overlay__item">
        <div
          className="discovery-content-results-image-overlay__item-container"
          title={__t(`${msgKey}.labels.engagement_rate`)}
        >
          {this.renderIcon('rotation-arrows-custom-fg')}
          <div className="discovery-content-results-image-overlay__item-value">
            {engagementRate < 10 ? engagementRate.toFixed(1) : Math.round(engagementRate)}%
          </div>
        </div>
      </div>
    );
  }

  renderDate(): React.ReactNode {
    const { date } = this.props;

    return (
      <div className="discovery-content-results-image-overlay__item">
        <div className="discovery-content-results-image-overlay__item-container">
          <div className="discovery-content-results-image-overlay__item-value">
            {getDisplayDate(date)}
          </div>
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    const { likes, comments, engagementRate, date, size } = this.props;

    const containerClasses = classnames({
      'discovery-content-results-image-overlay': true,
      [`discovery-content-results-image-overlay--size-${size}`]: size
    });

    return (
      <div
        className={containerClasses}
        data-qa="discovery-content-results-image-overlay"
      >
        {
          likes &&
            this.renderLikes()
        }
        {
          comments &&
            this.renderComments()
        }
        {
          engagementRate &&
            this.renderEngagementRate()
        }
        {
          date &&
            this.renderDate()
        }
      </div>
    );
  }
}

export default DiscoveryContentImageOverlay;
